module.exports = __webpack_public_path__ + "static/media/bottom-bg-orange.24fb509f.svg";